module.exports = __webpack_public_path__ + "static/img/posture_equilibre_0.f0f49a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imageTests/posture_equilibre_0.png
// module id = Y5zh
// module chunks = 1